<div class="section-loader body-bg" *ngIf="loading">
    <div class="loader-inner ball-beat">
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
<div class="mContent__header bg-primary py-3 px-5 flex-auto">
    <h1 class="text-white mb-1">Tutor Directory</h1>
    <div class="mControls">
        <div class="input-group">
            <mat-form-field appearance="outline" class="input-white no-error">
                <mat-label>All Schools</mat-label>
                <mat-select [(ngModel)]="schoolSelected" (selectionChange)="onSchoolChange($event)">
                    <mat-option [value]="-1" > All Schools </mat-option>
                    <mat-option *ngFor="let school of schoolList" [value]="school.id">
                        {{school.school_name}} {{school.uuid?"("+school.uuid+")":''}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="input-group">
            <mat-form-field appearance="outline" class="input-white no-error">
                <mat-label>All Levels</mat-label>
                <mat-select [(ngModel)]="levelSelected" (selectionChange)="onLevelChange($event)">
                    <mat-option *ngFor="let level of levelList" [value]="level.id">
                        {{level.commitment_level}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="input-group mr-auto">
            <mat-form-field appearance="outline" class="input-white no-error">
                <mat-label>Search</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input type="text" matInput [(ngModel)]="tutorInfo.searchTerm" (keyup.enter)="onSearch()"
                    placeholder="Search by name" aria-label="Search">
                <button mat-button *ngIf="tutorInfo.searchTerm" matSuffix mat-icon-button aria-label="Clear"
                    (click)="tutorInfo.searchTerm='';onSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="mControls__right">
            <div *ngIf="this.loggedInUser!=3">
                <div class="input-group">
                    <button mat-raised-button [matMenuTriggerFor]="menu">
                        Add New <mat-icon>expand_more</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let action of tutorActions" (click)="tutorAction(action)">
                          {{ action }}
                        </button>
                    </mat-menu>    
                </div>
            </div>
        </div>
    </div>
</div>
<hr class="m-0 flex-fill overflow-auto">
<div *ngIf="filteredTutorList?.length>0" class="search-results h-100 m-3" infiniteScroll [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()" [scrollWindow]="false">
    <table class="table no-wrap m-0 table--hover">
        <thead>
            <tr>
                <th style="width:30%" scope="col">Name</th>
                <th style="width:20%" scope="col">Email</th>
                <th  style="width:20%" scope="col">Phone</th>
                <th style="width:20%" scope="col">Experience</th>
                <th  style="width:10%" scope="col"></th>
                <th style="width:100px" scope="col" *ngIf="selectedIndex === 0"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let tutor of filteredTutorList ">
                <td (click)="tutorProfile(tutor.id)" *ngIf="selectedIndex === 0">
                    {{tutor.UserName ? tutor.UserName : 'N/A'}}</td>
                <td (click)="tutorProfile(tutor.id)" *ngIf="selectedIndex === 0">
                    {{tutor.email ? tutor.email : 'N/A'}}</td>
                <td (click)="tutorProfile(tutor.id)" *ngIf="selectedIndex === 0">
                    {{tutor.phone ? tutor.phone : 'N/A'}}
                </td>

                <td (click)="tutorProfile(tutor.id)" *ngIf="selectedIndex === 0">
                    <span [class.bold_exp]="tutor.is_teacher_experience">T</span>/
                        <span [class.bold_exp]="tutor.is_counselor_experience">C</span>
                </td>
                <td>

                </td>

                <td>
                    <div *ngIf="this.loggedInUser!=3">
                        <a class="text-link" (click)="editTutor(tutor.id)" aria-hidden="false" aria-label="Edit">
                            <mat-icon>edit</mat-icon>
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="flex-fill d-flex flex-column align-items-center justify-content-center" *ngIf="!filteredTutorList?.length">
    <img src="assets/images/no-result.png" alt="">
    <h2>No Tutor Records</h2>
</div>

<div class="text-right flex-auto p-3 page-count">
    <span>{{ filteredTutorList?.length }}</span> of <span>{{ count }}</span></div>
<Style>
    .bold_exp {
        font-family: Impact, Charcoal, sans-serif;
    }
</Style>
